// src/layouts/RootLayout.tsx
import { Outlet } from "react-router";
import Sidebar from "components/navbars/sidebar/Sidebar";
import Header from "components/navbars/topbar/Header";
import { useState } from "react";

export type RootLayoutContextType = {
  setLogoUrl: (url: string | null) => void;
};

const RootLayout = () => {
  const [showMenu, setShowMenu] = useState(true);
  const [logoUrl, setLogoUrl] = useState<string | null>(null);

  const ToggleMenu = () => setShowMenu((prev) => !prev);

  return (
    <section className="bg-light">
      <div id="db-wrapper" className={`${showMenu ? "" : "toggled"}`}>
        <div className="navbar-vertical navbar">
          <Sidebar showMenu={showMenu} toggleMenu={ToggleMenu} />
        </div>

        <div id="page-content">
          <div className="header">
            <Header toggleMenu={ToggleMenu} logoUrl={logoUrl} />
          </div>

          {/* Provide setLogoUrl to nested routes (like DevicePage) */}
          <Outlet context={{ setLogoUrl }} />
        </div>
      </div>
    </section>
  );
};

export default RootLayout;
